// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__2xsja","PriceInfo":"style_PriceInfo__1lkgm","PriceTitle":"style_PriceTitle__3u5qq","PriceDescription":"style_PriceDescription__36UdW"};